import { useContext, useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { AuthContext } from '../../../Context'
import { AuthContextApi } from '../../../Context/api'
import {
    BuildingOfficeIcon,
    WrenchScrewdriverIcon,
    ArrowLeftIcon,
} from '@heroicons/react/24/outline'
import ObrasTable from '../../../Components/Table/Obras'
import VisualizacaoObra from '../../../Components/Modal/Obras/Visualizacao'

const InvestimentoInvestidor = () => {
    const { id: empreendimentoId } = useParams()
    const navigate = useNavigate()
    const { states, setters } = useContext(AuthContext)
    const { getObrasInvestidor } = useContext(AuthContextApi)

    const [obraPage, setObraPage] = useState(0)
    const [obraPerPage] = useState(10)

    const buildParams = (overrides = {}) => new URLSearchParams({
        empreendimento_id: empreendimentoId,
        page: obraPage,
        per_page: obraPerPage,
        ...overrides,
    }).toString()

    const loadObras = (overrides = {}) => getObrasInvestidor(buildParams(overrides))

    const viewObra = (data) => {
        setters.setObras(data)
        setters.setModalViewObras(true)
    }

    const openObraPainel = (data) => {
        const obraId = data.obra_id || data.id
        if (!obraId) return
        navigate(`/investidor/investimentos/investimento/${empreendimentoId}/obra/${obraId}`)
    }

    useEffect(() => {
        if (!empreendimentoId) return
        loadObras({ page: 0 })
        return () => setters.setDataObras([])
    }, [empreendimentoId])

    useEffect(() => {
        if (states.dataObras?.length > 0) loadObras()
    }, [obraPage])

    return (
        <>
            <div className="bg-white border-b border-gray-100 px-6 py-5">
                <div className="flex items-center gap-4">
                    <button
                        onClick={() => navigate('/investidor/investimentos')}
                        className="p-2 rounded-xl bg-gray-100 hover:bg-gray-200 text-gray-600 transition-colors"
                    >
                        <ArrowLeftIcon className="w-5 h-5" />
                    </button>
                    <div className="p-2 bg-gray-900 rounded-xl">
                        <BuildingOfficeIcon className="w-5 h-5 text-brand-yellow" />
                    </div>
                    <div>
                        <h1 className="text-lg font-bold text-gray-900">Obras do Empreendimento</h1>
                        <p className="text-sm text-gray-400">Selecione uma obra para visualizar o painel</p>
                    </div>
                </div>
            </div>

            <div className="px-6 pt-5 pb-6 space-y-4">
                <div className="flex items-center gap-2">
                    <div className="p-1.5 bg-gray-900 rounded-lg">
                        <WrenchScrewdriverIcon className="w-4 h-4 text-brand-yellow" />
                    </div>
                    <h2 className="text-base font-bold text-gray-900">Obras</h2>
                </div>

                <ObrasTable
                    data={states.dataObras ?? []}
                    loading={states.isLoading}
                    page={obraPage}
                    recordsPerPage={obraPerPage}
                    viewObra={viewObra}
                    openObraPainel={openObraPainel}
                    readOnly
                    next={() => setObraPage(p => p + 1)}
                    previous={() => setObraPage(p => Math.max(0, p - 1))}
                />
            </div>

            <VisualizacaoObra states={states} setters={setters} />
        </>
    )
}

export default InvestimentoInvestidor
